import { CREDITS_CHARGE_ACTION_TYPES } from '@modules/core/api/const';

export const getDirectBankActionNameBySubmissionsNumber = (submissionsNumber: number) => {
  if (submissionsNumber === 0) {
    return CREDITS_CHARGE_ACTION_TYPES.firstBankApplicationDirectToBankSubmit;
  }

  return CREDITS_CHARGE_ACTION_TYPES.otherBankApplicationDirectToBankSubmit;
};

export const getHuspyActionNameBySubmissionsNumber = (submissionsNumber: number) => {
  if (submissionsNumber === 0) {
    return CREDITS_CHARGE_ACTION_TYPES.firstBankApplicationToHuspySubmit;
  }

  if (submissionsNumber === 1) {
    return CREDITS_CHARGE_ACTION_TYPES.secondBankApplicationToHuspySubmit;
  }

  return CREDITS_CHARGE_ACTION_TYPES.otherBankApplicationToHuspySubmit;
};
